import React, { useState, useEffect, Fragment } from "react";
import * as yup from "yup";
import { Report, TonnageDisclaimer } from "../../../shared";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import urlParameterHelper from "../../../../utilities/urlParameters";

const schema = yup.object({
  epaId: yup.string().required("ID Number is required."),
  entityType: yup.string().required("Entity Type is required."),
  wasteCodeType: yup.string().required("Waste Code Type is required."),
});

function WasteCodeMatrixReport(props) {
  const backToUrl = "/reports";
  const pageTitle = "Waste Code By Year Matrix Report";
  const apiEndpoint = "api/v1/hwts/waste-codes/matrix";
  const location = useLocation();
  const params = queryString.parse(location.search);
  const [searchOnInit, setSearchOnInit] = useState(Object.keys(params).length > 0 ? true : false);

  const [initialFormValues, setInitialFormValues] = useState({
    epaId: params && params.epaId ? params.epaId : "",
    entityType: params && params.entityType ? params.entityType : "",
    wasteCodeType: params && params.wasteCodeType ? params.wasteCodeType : "",
  });

  const formConfig = [
    {
      name: "epaId",
      config: {
        label: "ID Number",
        col: "md",
        colWidth: "3",
        placeholder: "Enter an ID Number...",
        type: "text",
      },
    },
    {
      name: "entityType",
      config: {
        label: "Entity Type",
        col: "md",
        colWidth: "3",
        placeholder: "",
        type: "select",
        data: [
          {
            label: "Alt. TSDF",
            value: "AlternateDesignateFacility",
          },
          { label: "Generator", value: "generator" },
          { label: "Transporter", value: "transporter" },
          { label: "TSDF", value: "tsdf" },
        ],
      },
    },
    {
      name: "wasteCodeType",
      config: {
        label: "Waste Code Type",
        col: "md",
        colWidth: "3",
        placeholder: "",
        type: "select",
        data: [
          { label: "Non-RCRA", value: "ca" },
          { label: "RCRA", value: "rcra" },
        ],
      },
    },
  ];

  useEffect(() => {
    let qs = props.location.search;
    if (qs !== "") {
      const formValues = urlParameterHelper.parse(qs);
      setInitialFormValues(formValues);
      setSearchOnInit(true);
    }
  }, []);

  return (
    <Fragment>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: "View Waste Code Matrix", url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        searchOnInit={searchOnInit}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </Fragment>
  );
}

export default WasteCodeMatrixReport;
